import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { gql, useLazyQuery } from '@apollo/client';

import { Causals, Causals_causals as Causal } from '../graph-types/Causals';

const GET_CAUSALS = gql`
  query Causals {
    causals {
      id
      causal
    }
  }
`;

export { Causal };

type Props = {
  value: Causal | null;
  onSelect: (option: Causal | null) => void;
};

export const CausalAutocomplete: React.FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [getCausals, { loading, data, called }] = useLazyQuery<Causals>(GET_CAUSALS);

  const options = data?.causals ?? [];

  useEffect(() => {
    if (open && !called) {
      getCausals();
    }
  }, [open, called, getCausals]);

  return (
    <Autocomplete
      id="causals-autocomplete"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onChange={(event, newValue) => {
        props.onSelect(newValue);
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        return option.causal;
      }}
      options={props.value ? [props.value, ...options] : options}
      loading={loading}
      value={props.value}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin="dense"
          label="Causal"
          variant="outlined"
          name="causal-autocomplete"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
